module.exports = __webpack_public_path__ + "img/capsules.7debfdc1.png";